import { Text, View, StyleSheet } from '@react-pdf/renderer';
import { Course } from '../interfaces/store';


type CoursesPdfProps = {
  courses: Course[];
  fontColor: string; // e.g. 'rgb(59, 130, 246)'
};

const styles = StyleSheet.create({
  courseBlock: {
    marginBottom: 10,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  courseName: {
    fontSize: 12,
    color: 'black'
    // marginBottom: 4,
  }
});

export const CoursesPdf: React.FC<CoursesPdfProps> = ({ courses, fontColor }) => {
    const content = courses.map((course, i) => {
  
      if (fontColor) {
        styles.courseName.color = fontColor
      }
      
      return (
        <View key={i} style={[styles.courseBlock, {display: course.status === 'delete' ? 'none' : 'flex'}]}>
          <Text style={styles.courseName}>{course.name}</Text>
        </View>
      );
    });
  
    return <View>{content}</View>;
  };
  
  